module.exports = __webpack_public_path__ + "static/media/Pile_of_Coins@3x.48b82de7.png";